/** Static workflow starters — palette types match GET_CATALOG whatsapp.*.await / *.notify + generic.* */
export const WORKFLOW_TEMPLATES = [
  {
    id: "flash-offer",
    title: "Sell a product or run an offer",
    description: "Promotional message with Yes/No buttons and follow-up paths.",
    suggestedName: "Flash Offer Campaign",
    definition: {
      start: "nd_welcome",
      nodes: [
        {
          id: "nd_welcome",
          name: "Offer Message",
          paletteType: "whatsapp.buttons.await",
          config: {
            message: {
              type: "buttons",
              text: "Hi {{customer_name}}! We have an exclusive offer valid for 3 days. Interested?",
              options: [
                { id: "YES", label: "Yes, tell me more" },
                { id: "NO", label: "Not now" }
              ]
            }
          },
          transitions: {
            YES: "nd_offer_link",
            NO: "nd_goodbye",
            FALLBACK: "nd_welcome"
          }
        },
        {
          id: "nd_offer_link",
          name: "Send Offer Link",
          paletteType: "whatsapp.text.notify",
          config: {
            message: {
              type: "text",
              text: "Great! Here's your offer link: [Payment URL]. Offer expires in 72 hours."
            }
          },
          onSuccess: "nd_end"
        },
        {
          id: "nd_goodbye",
          name: "Polite Goodbye",
          paletteType: "whatsapp.text.notify",
          config: {
            message: {
              type: "text",
              text: "No problem! Reach out anytime if you change your mind."
            }
          },
          onSuccess: "nd_end"
        },
        {
          id: "nd_end",
          name: "End Workflow",
          paletteType: "generic.end",
          type: "END",
          config: {}
        }
      ]
    }
  },
  {
    id: "qr-register",
    title: "Register customers when they scan QR",
    description: "Welcome menu with product registration and support handoff.",
    suggestedName: "QR Product Registration",
    definition: {
      start: "nd_welcome",
      nodes: [
        {
          id: "nd_welcome",
          name: "Welcome Menu",
          paletteType: "whatsapp.buttons.await",
          config: {
            message: {
              type: "buttons",
              text: "Welcome to our store! How can we help you today?",
              options: [
                { id: "REGISTER", label: "Register Product" },
                { id: "SUPPORT", label: "Talk to Support" }
              ]
            }
          },
          transitions: {
            REGISTER: "nd_ask_product",
            SUPPORT: "nd_handoff",
            FALLBACK: "nd_welcome"
          }
        },
        {
          id: "nd_ask_product",
          name: "Ask for Product Name",
          paletteType: "generic.collect_input",
          type: "COLLECT_INPUT",
          config: {
            expectedType: "text",
            storeAs: "productName",
            prompt: "Please enter the product name you wish to register.",
            invalidTypeMessage: "Please type the product name as plain text."
          },
          onReceived: "nd_confirm"
        },
        {
          id: "nd_confirm",
          name: "Registration Confirmation",
          paletteType: "whatsapp.text.notify",
          config: {
            message: {
              type: "text",
              text: "Success! Your product '$context.productName' has been registered. Is there anything else we can do?"
            }
          },
          onSuccess: "nd_welcome"
        },
        {
          id: "nd_handoff",
          name: "Handoff to Agent",
          paletteType: "generic.handoff",
          type: "HANDOFF",
          config: {
            messageToUser: "Connecting you to a support agent. Please wait...",
            priority: "high"
          }
        }
      ]
    }
  },
  {
    id: "win-back",
    title: "Re-engage customers who went silent",
    description: "Check-in message with paths for happy customers or support.",
    suggestedName: "Win-Back Campaign",
    definition: {
      start: "nd_checkin",
      nodes: [
        {
          id: "nd_checkin",
          name: "Check-in Message",
          paletteType: "whatsapp.buttons.await",
          config: {
            message: {
              type: "buttons",
              text: "Hi {{customer_name}}, it's been a while! How is your {{product_model}} working for you?",
              options: [
                { id: "GREAT", label: "Working great" },
                { id: "HELP", label: "Need help" }
              ]
            }
          },
          transitions: {
            GREAT: "nd_thanks",
            HELP: "nd_handoff",
            FALLBACK: "nd_checkin"
          }
        },
        {
          id: "nd_thanks",
          name: "Thank You",
          paletteType: "whatsapp.text.notify",
          config: {
            message: {
              type: "text",
              text: "Glad to hear that! Let us know if you need anything."
            }
          },
          onSuccess: "nd_end"
        },
        {
          id: "nd_handoff",
          name: "Connect to Support",
          paletteType: "generic.handoff",
          type: "HANDOFF",
          config: {
            messageToUser: "Connecting you to our team...",
            priority: "normal"
          }
        },
        {
          id: "nd_end",
          name: "End Workflow",
          paletteType: "generic.end",
          type: "END",
          config: {}
        }
      ]
    }
  }
];

export function getWorkflowTemplate(templateId) {
  return WORKFLOW_TEMPLATES.find((template) => template.id === templateId) ?? null;
}
